import React from 'react';
import { Route, Routes } from 'react-router-dom';
import RequireAuth from '../components/auth/RequireAuth';
import ShipmentsList from '../pages/shipments/ShipmentsList';
import ShipmentDetail from '../pages/shipments/ShipmentDetail';
import CreateShipmentForm from '../pages/shipments/CreateShipmentForm';
import EditShipmentForm from '../pages/shipments/EditShipmentForm';
import TrackingPage from '../pages/tracking/TrackingPage';
import { UserRole } from '../types/user';

export const ShipmentRoutes: React.FC = () => {
  return (
    <Routes>
      {/* Public tracking route */}
      <Route path="track" element={<TrackingPage />} />
      
      {/* Protected shipment management routes */}
      <Route
        index
        element={
          <RequireAuth>
            <ShipmentsList />
          </RequireAuth>
        }
      />
      
      <Route
        path="new"
        element={
          <RequireAuth allowedRoles={[UserRole.ADMIN, UserRole.MANAGER]}>
            <CreateShipmentForm />
          </RequireAuth>
        }
      />
      
      <Route
        path="edit/:trackingNumber"
        element={
          <RequireAuth allowedRoles={[UserRole.ADMIN, UserRole.MANAGER]}>
            <EditShipmentForm />
          </RequireAuth>
        }
      />
      
      <Route
        path=":trackingNumber"
        element={
          <RequireAuth>
            <ShipmentDetail />
          </RequireAuth>
        }
      />
      
      {/* Add more shipment-related routes as needed */}
    </Routes>
  );
};

export default ShipmentRoutes;
